module.exports = __webpack_public_path__ + "static/media/short leave.a76f78d8.svg";